import type { LucideIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import { cn } from '../../utils/cn';

interface StatCardProps {
  label: string;
  value: number | string;
  icon: LucideIcon;
  tone?: 'default' | 'warning' | 'danger' | 'success';
  index?: number;
}

const toneClasses = {
  default: 'text-pulse-600 bg-pulse-50 dark:bg-pulse-900/30 dark:text-pulse-300',
  warning: 'text-amber-600 bg-amber-50 dark:bg-amber-900/30 dark:text-amber-300',
  danger: 'text-rose-600 bg-rose-50 dark:bg-rose-900/30 dark:text-rose-300',
  success: 'text-emerald-600 bg-emerald-50 dark:bg-emerald-900/30 dark:text-emerald-300',
} as const;

export function StatCard({ label, value, icon: Icon, tone = 'default', index = 0 }: StatCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, delay: index * 0.05 }}
    >
      <Card className="flex items-center gap-4 p-5">
        <div className={cn('flex h-11 w-11 shrink-0 items-center justify-center rounded-xl', toneClasses[tone])}>
          <Icon size={20} />
        </div>
        <div>
          <p className="text-2xl font-bold tabular-nums text-slate-900 dark:text-white">{value}</p>
          <p className="text-sm text-slate-500 dark:text-slate-400">{label}</p>
        </div>
      </Card>
    </motion.div>
  );
}
